import { CheckIcon } from './icons';

const STEPS = ['Your details', 'Your vehicle', 'Payment'];

export function Stepper({ step }: { step: 1 | 2 | 3 }) {
  return (
    <ol className="cbf-stepper" aria-label="Booking steps">
      {STEPS.map((label, i) => {
        const n = (i + 1) as 1 | 2 | 3;
        const done = n < step;
        return (
          <li key={label} aria-current={n === step ? 'step' : undefined} className={done ? 'is-done' : undefined}>
            <span className="cbf-step-num" aria-hidden="true">
              {done ? <CheckIcon size={18} /> : n}
            </span>
            <span>
              <span className="cbf-sr">{done ? 'Completed: ' : n === step ? 'Current: ' : ''}</span>
              {label}
            </span>
            {i < STEPS.length - 1 ? <span className="cbf-step-line" aria-hidden="true" /> : null}
          </li>
        );
      })}
    </ol>
  );
}
